import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { isJson } from "utils/json";

const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);

	return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
	userSelect: "none",
	height: "5vh",
	padding: ".35714286em .78571429em",
	margin: `0 ${grid}px 0 0`,
	borderRadius: ".28571429rem",
	boxShadow: "0 0 0 1px rgb(34 36 38 / 15%) inset",
	fontWeight: "700",
	fontSize: "1em",
	color: "rgba(0,0,0,.6)",
	background: isDragging ? "lightgreen" : "#e8e8e8",
	// styles we need to apply on draggables
	...draggableStyle,
});

const getListStyle = () => ({
	//   background: isDraggingOver ? 'lightblue' : 'white',
	display: "flex",
	padding: grid,
	overflow: "auto",
	maxHeight: "30vh",
	marginBottom: "2vh",
	flexDirection: "column",
});

const HorizontalOrder = ({ data, update }) => {
	const onDragEnd = (result) => {
		// dropped outside the list
		if (!result.destination) {
			return;
		}

		const items = reorder(data, result.source.index, result.destination.index);
		update(items);
	};

	return (
		<DragDropContext onDragEnd={onDragEnd}>
			<Droppable
				droppableId="droppable" //direction="vertical"
			>
				{(provided, snapshot) => (
					<div ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)} {...provided.droppableProps}>
						{data
							.filter((i) => isJson(i))
							.map((item, index) => {
								const value = JSON.parse(item);
								return (
									<Draggable key={value.id} draggableId={value.id.toString()} index={index}>
										{(provided, snapshot) => (
											<div
												ref={provided.innerRef}
												{...provided.draggableProps}
												{...provided.dragHandleProps}
												style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
											>
												<div>
													{value.name ? value.name : value.code}
													{/* <Button 
                       onClick={() => deleteItems(item)}
                      style={{backgroundColor: 'transparent'}} size='mini' icon='delete'></Button> */}
												</div>
											</div>
										)}
									</Draggable>
								);
							})}
						{provided.placeholder}
					</div>
				)}
			</Droppable>
		</DragDropContext>
	);
};

export default HorizontalOrder;
